module.exports = __webpack_public_path__ + "ss-glyphish-filled.svg?fac7a16f3748667c72fc834bfb225bcc";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ss-glyphish-filled.svg
// module id = 351
// module chunks = 0